import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'

import { GeotokenProvider, GeotokenSettingsProvider } from '../../../../Contexts'
import { GeotokenSettingsItemToolbar } from '../../../../Toolbar'
import WorldBasePage from '../../../WorldBasePage'
import GeotokenSettingsDetails from './SettingsDetails'

const GeotokenSettingsPage: React.FC = () => {
  const { id } = useParams()
  const quadkeyRequested = Quadkey.fromBase4String(id) ?? Quadkey.root

  return (
    <WorldBasePage toolbar={<GeotokenSettingsItemToolbar />}>
      <GeotokenProvider quadkey={quadkeyRequested}>
        <GeotokenSettingsProvider>
          <Helmet title="Geotoken Details" />
          <GeotokenSettingsDetails />
        </GeotokenSettingsProvider>
      </GeotokenProvider>
    </WorldBasePage>
  )
}

export { GeotokenSettingsDetails, GeotokenSettingsPage }
